import styled from "@emotion/styled";
import { FC } from "react";

type JobProps = {
  title: string;
  description: string;
};

const JobStyled = styled("div")(() => ({
  gridColumn: "span 1",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  marginTop: "1rem",
  "@media (max-width: 768px)": {
    "&:first-of-type": {
      marginTop: 0,
    },
  },
}));

const JobTitle = styled("h5")(() => ({
  fontSize: "1.5rem",
  fontWeight: 400,
  letterSpacing: -2,
  margin: 0,
}));

const JobContent = styled("p")(() => ({
  margin: 0,
  display: "flex",
  flexDirection: "column",
  padding: 0,
  textAlign: "left",
  fontSize: 14,
}));

const Job: FC<JobProps> = (props) => {
  return (
    <JobStyled>
      <JobTitle>{props.title}</JobTitle>
      <JobContent>{props.description}</JobContent>
    </JobStyled>
  );
};

export default Job;
